if (!Array.prototype.last) {
    Array.prototype.last = function last() {
        return this[this.length - 1];
    };
}
